import script from "./addTokenContractPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./addTokenContractPopup.vue?vue&type=script&setup=true&lang=js"

import "./addTokenContractPopup.vue?vue&type=style&index=0&id=8969f6a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8969f6a8"]])

export default __exports__